module.exports = __webpack_public_path__ + "static/media/carouselBgHome.e90a5e2f.jpg";